import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStocks = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <g
      stroke='currentColor'
      strokeLinecap='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      clipPath='url(#stocks_svg__a)'
    >
      <path d='M12.984 11.278c-.08.3-.041.62.104.89.146.27.388.47.673.554l1.19.298c.253.06.518.01.737-.134a1.03 1.03 0 0 0 .433-.639.95.95 0 0 0 .01-.645.9.9 0 0 0-.403-.489l-1.76-1.185a.9.9 0 0 1-.41-.487.95.95 0 0 1 .006-.647 1.03 1.03 0 0 1 .434-.64.95.95 0 0 1 .736-.134l1.19.32c.288.084.532.284.68.557.147.272.186.595.108.897M14.233 12.907l-.148.619M15.53 7.536l-.156.65' />
      <path d='m22.908 10.145-1.072 4.938c-.984 4.268-2.813 5.99-6.334 5.639a12 12 0 0 1-1.83-.32l-1.889-.474c-4.701-1.165-6.157-3.598-5.045-8.536l1.101-4.949c.184-.896.465-1.767.836-2.598C9.964.99 12.206.217 15.935 1.155l1.966.464c4.673 1.154 6.119 3.587 5.007 8.526Z' />
      <path d='M15.472 20.722c-.822.55-1.712.98-2.646 1.278l-1.78.619c-4.475 1.515-6.826.247-8.282-4.444l-1.446-4.67c-1.446-4.69-.246-7.165 4.23-8.68l1.78-.619c.462-.155.905-.278 1.318-.371a13 13 0 0 0-.836 2.598L6.708 11.38c-1.101 4.939.354 7.372 5.046 8.536l1.889.475q.903.232 1.83.32z' />
    </g>
    <defs>
      <clipPath id='stocks_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStocks;
